import { useState, useEffect } from "react";
import Sidebar from "../Sidebar";
import {
  Container,
  Col,
  Row,
  Button,
  Form,
  Table,
  Modal,
  InputGroup,
  Spinner,
  OverlayTrigger, 
  Tooltip
} from "react-bootstrap";
import DashboardHeader from "../DashboardHeader";
import "../css/Dashboard.css";
import "../css/Custom.css";
import Footer from "../DashboardFooter";
import Collapse from "react-bootstrap/Collapse";
import { toast, Toaster } from "react-hot-toast";
import { IoIosArrowDown } from "react-icons/io"; // for toggle icon
import {
  getAllPresaleListedByAddress,
  submitWithdrawRequest,
  getLiquidityFormDetailsByUser,
  updateLiquidityTable,
  submitRemoveLiquidityRequest,
  updateDurationAfterChange,
  registerBot,
  updateBot,
  getBotDetails
} from "../../../Action/action";
import {
  LPBalance,
  PoolBalances,
  ReceivableAmountAfterRemovingLiquidity,
  ApproveUsdtToken,
  ApproveToken,
  RemovalStatus,
  getTokenPriceSwap,
  UsdtAmount2,
  AddLiquidity,
  RemoveLiquidity,
  addBotUsdt,
  addBotToken,
  addBotNative,
  getBotTokenBalance,
  getBotUsdtBalance,
  getBotNativeBalance,
  haltBot,
  resumeBot,
  getUserInfiBalance,
  getBotFee,
  getBotStatus,
  removeBotToken,
  removeBotUsdt,
  removeBotNative
} from "../../../Web3/Liquidity/swapConnector";
import Web3WalletProvider from "../../../ConnectWallet/walletProvider";
import { useDisconnect, useAccount } from "wagmi";
import {
  UpdateSaleDuration,
  WithdrawTokens,
  WithdrawStatus2,
  SaleStatus,
  TokenSaleDuration,
} from "../../../Web3/Connector";
import { error } from "ajv/dist/vocabularies/applicator/dependencies";
import { showLoader, hideLoader } from "../../loader";
import config from "../../../config/config";
import { useParams } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/bootstrap.css';
import {isValidPhoneNumber} from 'libphonenumber-js'


const DashboardHome = ({ special, clearModalData }) => {
  let { walletAddress } = useParams();
  const [isOpen, setIsOpen] = useState(false); // Collapse toggle
  const [request, setRequest] = useState({
    reason: "",
    duration: "",
    agree: false,
  });
  const [errors, setErrors] = useState({});
  const [form, setForm] = useState([]);
  const _useWeb3WalletProvider = Web3WalletProvider();
  const { address, isConnected } = useAccount();
  const [isProviderLoaded, setisProviderLoaded] = useState(false);
  const [show, setShow] = useState(false);
  const [withdraw, setWithdraw] = useState(false);
  const [selectedItem, setItem] = useState({});

  const handleClose = () => setShow(false);
  const handleShow = (e, item) => {
    e.preventDefault();
    setItem(item);
    setShow(true);
  };

  const handleClose2 = () => setWithdraw(false);
  const handleShow2 = (e, item) => {
    e.preventDefault();
    setItem(item);
    setWithdraw(true);
  };
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
      const timer = setTimeout(() => {
        setIsLoading(false);
      }, 5000);
  
      return () => clearTimeout(timer);
    }, []);
  

  useEffect(() => {
    if (!isProviderLoaded) {
      _useWeb3WalletProvider.then((data) => {
        if (data) {
          setisProviderLoaded(true);
        }
      });
    }
  }, [_useWeb3WalletProvider]);

  useEffect(() => {
    if (isProviderLoaded) {
      getFormData();
      getLiquidityFormData();
    }
  }, [isProviderLoaded]);

  const getFormData = async () => {
    try {
      walletAddress = address;
      const response = await getAllPresaleListedByAddress({ walletAddress });
      if (response.success) {
        if (response.data.length > 0) {
          let dResult = await TokenSaleDuration(response.data);
          let withdraw = await WithdrawStatus2(response.data);
          let stat = await SaleStatus(response.data);
          for (let i = 0; i < response.data.length; i++) {
            response.data[i].newD = dResult?.duration[i];
            response.data[i].canWithdraw = withdraw?.can[i];
            response.data[i].isActive = stat?.isactive[i];
          }
        }
        setForm(response.data);
        console.log('form2',form)
      }
    } catch (error) {
      console.log(error);
    }
  };

  const validateRequest = async () => {
    const newErrors = {};
    if (!request.reason) newErrors.request = "Reason is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateDuration = async () => {
    const newErrors = {};
    if (!request.duration) newErrors.duration = "Duration is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = async (e) => {
    const { name, value } = e.target;

    setRequest({
      ...request,
      [name]: value,
    });

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const handleWithdrawal = async (e) => {
    e.preventDefault();
    if (!isConnected) {
      toast.error("Please connect your wallet");
      return;
    }
    showLoader();
    try {
      let request = {
        walletProvider: _useWeb3WalletProvider,
        tokenAddress: form[0].token_address,
        preSaleAddress: form[0].presaleContract,
        networkId: form[0].chainNetworkId,
      };

      let res = await WithdrawTokens(request);
      if (res.status) {
        toast.success(res.message);
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.log("Withdrawal Error", error);
      toast.error(error);
    } finally {
      hideLoader();
    }
  };
  const handleWithdrawRequest = async (e) => {
    e.preventDefault();
    if (await validateRequest()) {
      let data = {
        owner_address: address,
        token_name: selectedItem.token_name,
        token_address: selectedItem.token_address,
        reason: request.reason,
        chain: selectedItem.chain,
      };
      console.log("SUB", data);
      let result = await submitWithdrawRequest(data);
      setWithdraw(false);
      setRequest({ reason: "" });
      //console.log('SUB',result)
      if (result.success) {
        toast.success(result.msg);
      } else {
        toast.error(result.msg);
      }
    } else {
      toast.error("Please check validations required");
    }
  };

  const handleUpdateDuration = async (e) => {
    e.preventDefault();
    if (!isConnected) {
      toast.error("Please connect your wallet");
      return;
    }
    if (await validateDuration()) {
      showLoader();
      try {
        let input = {
          walletProvider: _useWeb3WalletProvider,
          tokenAddress: selectedItem.token_address,
          preSaleAddress: selectedItem.presaleContract,
          duration: request.duration,
          networkId: selectedItem.chainNetworkId,
        };

        let res = await UpdateSaleDuration(input);
        setShow(false);
        setRequest({ duration: "" });
        if (res.status) {
          toast.success(res.message);
          let data = {
            tokenAddress: input.tokenAddress,
            duration: input.duration,
          };
          await updateDurationAfterChange(data);
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        } else {
          toast.error(res.message);
        }
      } catch (error) {
        console.log("Error Updating duration", error);
        toast.error("Duration Update Error", error);
      } finally {
        hideLoader();
      }
    } else {
      toast.error("Please check validations required");
    }
  };

  //liquidity
  const [liqForm, setLiqForm] = useState([]);
  const [lpAmt, setLpAmt] = useState("");
  const [tokenAmt, setTokenAmt] = useState("");
  const [usdtAmtToAdd, setUsdtAmtToAdd] = useState("");
  const [expected, setExpected] = useState("");
  const [inputError, setInputError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [removeModal, setRemoveModal] = useState(false);
  const [selectedTokenItem, setSelectedTokenItem] = useState({});

  const handleModalClose = () => setShowModal(false);
  const handleModalShow = (e, item) => {
    e.preventDefault();
    setSelectedTokenItem(item);
    setShowModal(true);
  };

  const handleModalShow2 = (e, item) => {
    e.preventDefault();
    setSelectedTokenItem(item);
    setRemoveModal(true);
  };
  const handleModalClose2 = () => setRemoveModal(false);

  //bot
  const [selectedTokenBotItem, setSelectedTokenBotItem] = useState({});
  const [email, setEmail] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [botWallet, setBotWallet] = useState('')
  const [priceDiffPercent,setPriceDiffPercent] = useState('')

  const[usdtToDeposit,setUsdtToDeposit] = useState('')
  const [isDepositingUsdt, setIsDepositingUsdt] = useState(false);

  const [tokenToDeposit, setTokenToDeposit] = useState('')
  const [isDepositingToken, setIsDepositingToken] = useState(false);

  const [nativeToDeposit,setNativeToDeposit] = useState('')
  const [isDepositingNative, setIsDepositingNative] = useState(false);
  
  const[usdtToAddToBot,setUsdtToAddToBot] = useState('')
  const [isAddingUsdt, setIsAddingUsdt] = useState(false);

  const [tokenToAddToBot, setTokenToAddToBot] = useState('')
  const [isAddingToken, setIsAddingToken] = useState(false);

  const[botUsdtToWithdraw,setBotUsdtToWithdraw] = useState('')
  const [isRemovingUsdt, setIsRemovingUsdt] = useState(false);

  const[botTokenToWithdraw,setBotTokenToWithdraw] = useState('')
  const [isRemovingToken, setIsRemovingToken] = useState(false);

  const[botNativeToWithdraw,setBotNativeToWithdraw] = useState('')
  const [isRemovingNative, setIsRemovingNative] = useState(false);

  const [isGeneratingWallet, setIsGeneratingWallet] = useState(false)
  const [showBot, setShowBot] = useState(false);
  const [showBotSettings, setShowBotSettings] = useState(false);
  const [showBotWithdraw, setShowBotWithdraw] = useState(false)
  const [isBotHalted, setIsBotHalted] = useState(() => {
  const stored = localStorage.getItem("isBotHalted");
  return stored === null ? true : stored === "true";
});

useEffect(() => {
  if (isBotHalted !== null) {
    localStorage.setItem("isBotHalted", isBotHalted);
  }
}, [isBotHalted]);


  const [isHalting, setIsHalting] = useState(false);
  const [botAction, setBotAction] = useState("");

  const [showBuyInfiModal, setShowBuyInfiModal] = useState(false);

  const handleBotClose = () => {
    setShowBot(false);
    setSelectedTokenBotItem('')
    setUsdtToDeposit('')
    setTokenToDeposit('')
    setEmail('')
    setPhoneNumber('')
    //setBotWallet('')
    setInputError('')
  }

const handleBotShow = async (e, item) => {
  // alert('To enable bot, your token must be listed on atleast one of the below platforms: 1.Binance 2.Coinbase 3.CoinGecko 4.1inch 5.Uniswap 6.Pancakeswap 7.Quickswap 8.Sushiswap')
  if (!window.confirm("To enable bot, your token must be listed on one of the below platforms:\n1. Binance\n2. Coinbase\n3. CoinGecko\n4. 1inch\n5. Uniswap\n6. PancakeSwap\n7. QuickSwap\n8. SushiSwap")) {
  return;
}
  e.preventDefault();
  let walletAddress = address
  const infiBal = await getUserInfiBalance(walletAddress);
  console.log('User INFI balance:', infiBal);

  if (!infiBal.status) {
    toast.error(infiBal.message)
    console.error('Failed to fetch INFI balance:', infiBal.message);
    return;
  }
    if (infiBal.balance < 10) {
      setShowBuyInfiModal(true)
    return;
  }

  setSelectedTokenBotItem(item);
  setUsdtToDeposit(item.usdt_amount / 2);
  setTokenToDeposit(item.liquidity / 2);
  setShowBot(true);
  
};


  const handleBotSettingsShow = (e,item) => {
    e.preventDefault()
    setSelectedTokenBotItem(item)
    setUsdtToAddToBot()
    setTokenToAddToBot()
    setNativeToDeposit()
    setShowBotSettings(true);
  }

    const handleBotSettingsClose = () => {
    setShowBotSettings(false);
    setSelectedTokenBotItem('')
    setUsdtToAddToBot('')
    setTokenToAddToBot('')
    setNativeToDeposit('')
    setInputError('')
  }

  const handleBotWithdrawShow = (e,item) => {
    e.preventDefault()
    setShowBotSettings(false);
    setSelectedTokenBotItem(item)
    setBotUsdtToWithdraw()
    setBotTokenToWithdraw()
    setBotNativeToWithdraw()
    setShowBotWithdraw(true);
  }

    const handleBotWithdrawClose = () => {
    setShowBotWithdraw(false);
    setSelectedTokenBotItem('')
    setBotUsdtToWithdraw('')
    setBotTokenToWithdraw('')
    setBotNativeToWithdraw('')
    setInputError('')
  }



  const getLiquidityFormData = async () => {
    try {
      let walletAddress = address;
      const response = await getLiquidityFormDetailsByUser({ walletAddress });
      console.log('aa',response)
      if (response.success) {
        if (response.data.length > 0) {
          let pb = await PoolBalances(response.data);
          let tp = await getTokenPriceSwap(response.data);
          let lpb = await LPBalance(response.data);
          let remove = await RemovalStatus(response.data);
          let botTokenBal =  await getBotTokenBalance(response.data)
          let botUsdtBal =  await getBotUsdtBalance(response.data)
          let botNativeBal =  await getBotNativeBalance(response.data)
          let botFees = await getBotFee(response.data)
          let botStat = await getBotStatus(response.data)
          for (let i = 0; i < response.data.length; i++) {
            response.data[i].BALANCES = pb.data[i];
            response.data[i].PRICE = tp.data[i];
            response.data[i].LPBAL = lpb.data[i].balance;
            response.data[i].canRemove = remove.data[i];
            response.data[i].botBalToken = botTokenBal.data[i]
            response.data[i].botBalUsdt = botUsdtBal.data[i]
            response.data[i].botBalNative = botNativeBal.data[i]
            response.data[i].botFee = botFees.data[i]
            response.data[i].stat = botStat.data[i]
        }
          setLiqForm(response.data);
          console.log("l2", response.data);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const usdtToAdd = async (_tokenAmt) => {
        if(!isConnected) {
      toast.error("Please connect your wallet.");
      return
    }
    if (!selectedTokenItem) return 0;
    let request = {
      walletProvider: _useWeb3WalletProvider,
      tokenAddress: selectedTokenItem.token_address,
      tokenAmount: _tokenAmt,
      pairContractAddress: selectedTokenItem.pairContractAddress,
      networkId: selectedTokenItem.chainNetworkId,
    };
    const res = await UsdtAmount2(request);
    setUsdtAmtToAdd("");
    return res.Amount;
  };

  const removeLiquidityExpectedAmount = async (_lp) => {
        if(!isConnected) {
      toast.error("Please connect your wallet.");
      return
    }
    if (!selectedTokenItem) return 0;
    let request = {
      walletProvider: _useWeb3WalletProvider,
      tokenAddress: selectedTokenItem.token_address,
      pairContractAddress: selectedTokenItem.pairContractAddress,
      lpAmount: _lp,
      networkId: selectedTokenItem.chainNetworkId,
    };
    const res = await ReceivableAmountAfterRemovingLiquidity(request);
    setExpected("");
    return res.data;
  };

  // const handleAddLiquidity = async (e) => {
  //   e.preventDefault();
  //   if (!isConnected) {
  //     toast.error("Please connect your wallet");
  //     return;
  //   }
  //   showLoader();
  //   try {
  //     let request = {
  //       walletProvider: _useWeb3WalletProvider,
  //       tokenAddress: selectedTokenItem.token_address,
  //       tokenAmount: tokenAmt,
  //       pairContractAddress: selectedTokenItem.pairContractAddress,
  //       usdtAddress: selectedTokenItem.usdtContract,
  //       usdtAmount: usdtAmtToAdd,
  //       networkId: selectedTokenItem.chainNetworkId,
  //     };
  //     //       console.log('ADDD', request)
  //     let usdtApproval = await ApproveUsdtToken(request);
  //     if (usdtApproval.status) {
  //       let tokenApproval = await ApproveToken(request);
  //       if (tokenApproval.status) {
  //         let resAdd = await AddLiquidity(request);
  //         //             console.log('add liquid', resAdd)
  //         if (resAdd.status) {
  //           toast.success(resAdd.message);
  //           setTokenAmt("");
  //           setUsdtAmtToAdd("");
  //           handleModalClose();
  //           let data = {
  //             usdt_amount: request.usdtAmount,
  //             liquidity: request.tokenAmount,
  //           };
  //           //               console.log("DB", data)
  //           await updateLiquidityTable(data);
  //         } else {
  //           console.log("Add liquidty error", error);
  //           toast.error(resAdd.message);
  //         }
  //       } else {
  //         console.log("Token liquidity approval error", error);
  //         toast.error(tokenApproval.message);
  //       }
  //     } else {
  //       console.log("usdt liquidity approval error", error);
  //       toast.error(usdtApproval.message);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   } finally {
  //     hideLoader();
  //   }
  // };


  const handleAddLiquidity = async (e) => {
  e.preventDefault();

  if (!isConnected) {
    toast.error("Please connect your wallet");
    return;
  }

  showLoader();

  try {
    const request = {
      walletProvider: _useWeb3WalletProvider,
      tokenAddress: selectedTokenItem.token_address,
      tokenAmount: tokenAmt,
      pairContractAddress: selectedTokenItem.pairContractAddress,
      usdtAddress: selectedTokenItem.usdtContract,
      usdtAmount: usdtAmtToAdd,
      networkId: selectedTokenItem.chainNetworkId,
    };

    // Step 1: Approve USDT
    const usdtApproval = await ApproveUsdtToken(request);
    if (!usdtApproval.status) {
      toast.error(usdtApproval.message || "USDT approval failed");
      return;
    }
    if (!usdtApproval.alreadyApproved) {
      toast.success("USDT approved successfully");
    }

    // Step 2: Approve Token
    const tokenApproval = await ApproveToken(request);
    if (!tokenApproval.status) {
      toast.error(tokenApproval.message || "Token approval failed");
      return;
    }
    if (!tokenApproval.alreadyApproved) {
      toast.success("Token approved successfully");
    }

    // Step 3: Add Liquidity
    const resAdd = await AddLiquidity(request);
    if (resAdd.status) {
      toast.success(resAdd.message);
      setTokenAmt("");
      setUsdtAmtToAdd("");
      handleModalClose();

      const data = {
        usdt_amount: request.usdtAmount,
        liquidity: request.tokenAmount,
      };
      await updateLiquidityTable(data);
    } else {
      toast.error(resAdd.message || "Failed to add liquidity");
    }

  } catch (error) {
    console.error("Add Liquidity Error:", error);
    toast.error("Unexpected error occurred while adding liquidity");
  } finally {
    hideLoader();
  }
};

  const requestRemoveLiquidity = async () => {
    let data = {
      owner_address: selectedTokenItem.owner_address,
      pair_name: selectedTokenItem.pair_name,
      token_address: selectedTokenItem.token_address,
      chain: selectedTokenItem.chain,
    };
    let res = await submitRemoveLiquidityRequest(data);
    //console.log('RDB', res)
    if (res.success) {
      toast.success(res.msg);
    } else {
      toast.error(res.msg);
    }
    console.log("requestRemove function called!");
  };

  const handleRemoveLiquidity = async (e) => {
    e.preventDefault();
    if (!isConnected) {
      toast.error("Please connect your wallet");
      return;
    }
    showLoader();
    try {
      let request = {
        walletProvider: _useWeb3WalletProvider,
        tokenAddress: selectedTokenItem.token_address,
        pairContractAddress: selectedTokenItem.pairContractAddress,
        lpAmount: lpAmt,
        networkId: selectedTokenItem.chainNetworkId,
      };
      //  console.log("R",request.usdtAmount)
      let resRemove = await RemoveLiquidity(request);
      if (resRemove.status) {
        toast.success(resRemove.message);
        setLpAmt("");
        setExpected("");
        handleModalClose2();
      } else {
        console.log("Remove liquidty error", error);
        toast.error(resRemove.message);
        setLpAmt("");
      }
    } catch (error) {
      console.log(error);
    } finally {
      hideLoader();
    }
  };

  const handleUsdtDeposit = async (e) => {
    e.preventDefault();
    if (!isConnected) {
      toast.error("Please connect your wallet");
      return;
    }
    setIsDepositingUsdt(true)
    try {
      let request = {
        walletProvider: _useWeb3WalletProvider,
        usdtAddress: selectedTokenBotItem.usdtContract,
        botWallet: botWallet,
        usdtAmount: usdtToDeposit,
        networkId: selectedTokenBotItem.chainNetworkId,
      };
      console.log("R",request)
      let depositUsdt = await addBotUsdt(request);
      if (depositUsdt.status) {
        toast.success(depositUsdt.message);
      } else {
        console.log("Error adding usdt to bot", error);
        toast.error(depositUsdt.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsDepositingUsdt(false)
    }
  }

  const handleTokenDeposit = async (e) => {
    e.preventDefault();
    if (!isConnected) {
      toast.error("Please connect your wallet");
      return;
    }
    setIsDepositingToken(true)
    try {
      let request = {
        walletProvider: _useWeb3WalletProvider,
        tokenAddress: selectedTokenBotItem.token_address,
        botWallet: botWallet,
        tokenAmount: tokenToDeposit,
        networkId: selectedTokenBotItem.chainNetworkId,
      };
      console.log("R",request)
      let depositToken = await addBotToken(request);
      if (depositToken.status) {
        toast.success(depositToken.message);
      } else {
        console.log("Error adding token to bot", error);
        toast.error(depositToken.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsDepositingToken(false)
    }
  }


const handleNativeDeposit = async (e) => {
  e.preventDefault();

  if (!isConnected) {
    toast.error("Please connect your wallet");
    return;
  }

  setIsDepositingNative(true);

  try {
    let request = {
      walletProvider: _useWeb3WalletProvider,
      botWallet: botWallet || selectedTokenBotItem.bot_wallet_address,
      usdtAddress: selectedTokenBotItem.usdtContract,
      tokenAddress: selectedTokenBotItem.token_address,
      usdtAmount: usdtToDeposit,
      tokenAmount: tokenToDeposit,
      nativeAmount: nativeToDeposit,
      networkId: selectedTokenBotItem.chainNetworkId,
    };

    console.log("Request:", request);

    const depositUsdt = await addBotUsdt(request);
    if (!depositUsdt.status) {
      console.log("Error adding USDT to bot", depositUsdt.message);
      toast.error(depositUsdt.message);
      return;
    }

    const depositToken = await addBotToken(request);
    if (!depositToken.status) {
      console.log("Error adding token to bot", depositToken.message);
      toast.error(depositToken.message);
      return;
    }

    const depositNative = await addBotNative(request);
    if (!depositNative.status) {
      console.log("Error adding native to bot", depositNative.message);
      toast.error(depositNative.message);
      return;
    }

    setIsBotHalted(false);
    localStorage.setItem("isBotHalted", "false");

    let data = {
      tokenAddress: selectedTokenBotItem.token_address,
      nativeAmount: nativeToDeposit,
    }
    await updateBot(data)


    toast.success(depositNative.message);
    setShowBot(false);
    setTimeout(() => window.location.reload(), 1000);

  } catch (error) {
    console.log("Deposit error:", error);
    toast.error("An error occurred while depositing.");
  } finally {
    setIsDepositingNative(false);
  }
};


    const handleUsdtToAdd = async (e) => {
    e.preventDefault();
    if (!isConnected) {
      toast.error("Please connect your wallet");
      return;
    }
    setIsAddingUsdt(true)
    try {
      let request = {
        walletProvider: _useWeb3WalletProvider,
        usdtAddress: selectedTokenBotItem.usdtContract,
        botWallet: selectedTokenBotItem.bot_wallet_address,
        usdtAmount: usdtToAddToBot,
        networkId: selectedTokenBotItem.chainNetworkId,
      };
      console.log("R",request)
      let depositUsdt = await addBotUsdt(request);
      if (depositUsdt.status) {
        toast.success(depositUsdt.message);
        setUsdtToAddToBot('')
      } else {
        console.log("Error adding usdt to bot", error);
        toast.error(depositUsdt.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsAddingUsdt(false)
    }
  }

  const handleTokenToAdd = async (e) => {
    e.preventDefault();
    if (!isConnected) {
      toast.error("Please connect your wallet");
      return;
    }
    setIsAddingToken(true)
    try {
      let request = {
        walletProvider: _useWeb3WalletProvider,
        tokenAddress: selectedTokenBotItem.token_address,
        botWallet: selectedTokenBotItem.bot_wallet_address,
        tokenAmount: tokenToAddToBot,
        networkId: selectedTokenBotItem.chainNetworkId,
      };
      console.log("R",request)
      let depositToken = await addBotToken(request);
      if (depositToken.status) {
        toast.success(depositToken.message);
        setTokenToAddToBot('')
      } else {
        console.log("Error adding token to bot", error);
        toast.error(depositToken.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsAddingToken(false)
    }
  }

  const handleUsdtToWithdraw = async (e) => {
    e.preventDefault();
    if (!isConnected) {
      toast.error("Please connect your wallet");
      return;
    }
    setIsRemovingUsdt(true)
    try {
      let request = {
        walletProvider: _useWeb3WalletProvider,
        usdtAddress: selectedTokenBotItem.usdtContract,
        tokenAddress: selectedTokenBotItem.token_address,
        botWallet: selectedTokenBotItem.bot_wallet_address,
        usdtAmount: botUsdtToWithdraw,
        networkId: selectedTokenBotItem.chainNetworkId,
      };
      let botDetails = await getBotDetails(request)
      //console.log('babu',botDetails.data[0].encryption)
      let withdrawUsdt = await removeBotUsdt(request,botDetails.data[0].encryption);
      if (withdrawUsdt.status) {
        toast.success(withdrawUsdt.message);
        setBotUsdtToWithdraw('')
      } else {
        console.log("Error removing usdt from bot", error);
        toast.error(withdrawUsdt.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsRemovingUsdt(false)
    }
  }

  const handleTokenToWithdraw = async (e) => {
    e.preventDefault();
    if (!isConnected) {
      toast.error("Please connect your wallet");
      return;
    }
    setIsRemovingToken(true)
    try {
      let request = {
        walletProvider: _useWeb3WalletProvider,
        tokenAddress: selectedTokenBotItem.token_address,
        botWallet: selectedTokenBotItem.bot_wallet_address,
        tokenAmount: botTokenToWithdraw,
        networkId: selectedTokenBotItem.chainNetworkId,
      };
      console.log("R",request)
      let botDetails = await getBotDetails(request)
      let withdrawToken = await removeBotToken(request,botDetails.data[0].encryption);
      if (withdrawToken.status) {
        toast.success(withdrawToken.message);
        setBotTokenToWithdraw('')
      } else {
        console.log("Error removing token from bot", error);
        toast.error(withdrawToken.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsRemovingToken(false)
    }
  }

  const handleNativeToWithdraw = async (e) => {
    e.preventDefault();
    if (!isConnected) {
      toast.error("Please connect your wallet");
      return;
    }
    setIsRemovingNative(true)
    try {
      let request = {
        walletProvider: _useWeb3WalletProvider,
        tokenAddress: selectedTokenBotItem.token_address,
        botWallet: botWallet || selectedTokenBotItem.bot_wallet_address,
        nativeAmount: botNativeToWithdraw,
        networkId: selectedTokenBotItem.chainNetworkId,
      };
      console.log("R",request)
      let botDetails = await getBotDetails(request)
      let withdrawNative = await removeBotNative(request,botDetails.data[0].encryption);
      if (withdrawNative.status) {
        toast.success(withdrawNative.message);
        setBotNativeToWithdraw('')
      } else {
        console.log("Error adding native to bot", error);
        toast.error(withdrawNative.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsRemovingNative(false)
    }
  }


const handleBotStatus = async (e) => {
      if(!isConnected) {
      toast.error("Please connect your wallet.");
      return
    }
  e.preventDefault();

  setIsHalting(true)
  setBotAction(isBotHalted ? "starting" : "stopping");

  try {
    let request = {
      walletProvider: _useWeb3WalletProvider,
      tokenAddress: selectedTokenBotItem.token_address,
      botAddress: selectedTokenBotItem.botContract,
      networkId: selectedTokenBotItem.chainNetworkId,
    };

    console.log("stop:", request);
    if (isBotHalted) {
      // Resume bot
      let startBot = await resumeBot(request);
      if (startBot.status) {
        toast.success(startBot.message);
        setIsBotHalted(false);
        localStorage.setItem("isBotHalted", "false");
      } else {
        toast.error(startBot.message);
      }
    } else {
      // Halt bot
      let stopBot = await haltBot(request);
      if (stopBot.status) {
        toast.success(stopBot.message);
        setIsBotHalted(true);
        localStorage.setItem("isBotHalted", "true");
      } else {
        toast.error(stopBot.message);
      }
    }
  } catch (error) {
    console.log("Bot status change error:", error);
    toast.error("Something went wrong while changing bot status.");
  } finally {
    setIsHalting(false)
    setBotAction("")
  }
};



  const inputhandler = async (e) => {
    e.preventDefault();
    let newToken = e.target.value;
    if (!/^\d*\.?\d*$/.test(newToken)) {
      setInputError("Please enter a valid number");
      setTokenAmt(newToken);
      setUsdtAmtToAdd("");
      return;
    }
    setInputError("");
    setTokenAmt(newToken);
    let res = await usdtToAdd(newToken);
    //console.log('newus',res,newToken)
    setUsdtAmtToAdd(res);
  };

  const inputhandler2 = async (e) => {
    e.preventDefault();
    let newLP = e.target.value;
    if (!/^\d*\.?\d*$/.test(newLP)) {
      setInputError("Please enter a valid number");
      setLpAmt(newLP);
      setExpected("");
      return;
    }
    setInputError("");
    setLpAmt(newLP);
    let res2 = await removeLiquidityExpectedAmount(newLP);
    setExpected(res2);
  };

  const inputhandler3 = async (e) => {
    let mail = e.target.value;
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mail)) {
      setInputError("Please enter a valid email");
      setEmail(mail);
      return;
    }
    setInputError("");
    setEmail(mail);
  };

  const inputhandler4 = async (e) => {
    e.preventDefault();
    let native = e.target.value
    if (native < "0.5") {
      setInputError("Min 0.5 is required");
      setNativeToDeposit(native);
      return;
    }
    setInputError("");
    setNativeToDeposit(native);
  };

  const inputhandler5 = async (e) => {
    e.preventDefault();
    let priceD = e.target.value
    if (priceD <= "0") {
      setInputError("Price difference cannot be 0");
      setPriceDiffPercent(priceD);
      return;
    }
    setInputError("");
    setPriceDiffPercent(priceD)
  };

  const phoneInputhandler = async (value) => {
    setPhoneNumber(value);
    if(!isValidPhoneNumber(value)) {
      setInputError('Invalid phone number')
    } else {
      setInputError('')
    }
  }


    const addTokeninputhandler = async (e) => {
    e.preventDefault();
    let token = e.target.value
    if (token <= "0") {
      setInputError("Cannot be 0");
      setTokenToAddToBot(token);
      return;
    }
    setInputError("");
      setTokenToAddToBot(token);
  };

    const addUsdtinputhandler = async (e) => {
    e.preventDefault();
    let usdt = e.target.value
    if (usdt <= "0") {
      setInputError("Cannot be 0");
      setUsdtToAddToBot(usdt);
      return;
    }
    setInputError("");
      setUsdtToAddToBot(usdt);
  };


  const withdrawUsdtinputhandler = async (e) => {
    e.preventDefault();
    let usdt = e.target.value
    if (usdt <= "0") {
      setInputError("Cannot be 0");
    } else if (usdt > selectedTokenBotItem.botBalUsdt) {
      setInputError(`Cannot be more than ${selectedTokenBotItem.botBalUsdt}`)
    } else {
      setInputError("");
    }
    setBotUsdtToWithdraw(usdt);
  };


  const withdrawTokeninputhandler = async (e) => {
    e.preventDefault();
    let token = e.target.value
    if (token <= "0") {
      setInputError("Cannot be 0");
    } else if (token > selectedTokenBotItem.botBalToken) {
      setInputError(`Cannot be more than ${selectedTokenBotItem.botBalToken}`)
    } else {
      setInputError("");
    }
      setBotTokenToWithdraw(token);
  };

  const withdrawNativeinputhandler = async (e) => {
    e.preventDefault();
    let native = e.target.value
    if (native < "0") {
      setBotNativeToWithdraw(native);
    } else if (native > selectedTokenBotItem.botBalNative) {
      setInputError(`Cannot be more than ${selectedTokenBotItem.botBalNative}`)
    } else {
      setInputError("");
    }
    setBotNativeToWithdraw(native);
  };

  const renderTooltipUSDT = (props) => (
    <Tooltip id="usdt-tooltip" {...props}>
      You will be charged in USDT (e.g., 1 USDT)
    </Tooltip>
  );



  

  const handleBotWalletCreate = async (e) => {
    e.preventDefault()
        if(!isConnected) {
          toast.error("Please connect your wallet.");
          return
        }
    setIsGeneratingWallet(true)
    try {
    const data = {
      tokenAddress: selectedTokenBotItem.token_address,
      chain: selectedTokenBotItem.chain,
      symbol: selectedTokenBotItem.token_symbol,
      email: email,
      phone: phoneNumber,
      priceDifference: priceDiffPercent,
      initialTokenBalance:tokenToDeposit,
      initialUsdtBalance:usdtToDeposit,
      initialNativeBalance:nativeToDeposit
     }
    const res = await registerBot(data)
    if(res.status) {
      setBotWallet(res.wallet)
    } else {
      toast.error(res.message)
    }
  } catch (error) {
      console.log('Error generating wallet',error);
    } finally {
      setIsGeneratingWallet(false)
    }
  }



  

  return (
    <>
      <Toaster />
      <div
        className="dashboard w-100"
        style={{ minHeight: "100vh", overflow: "hidden" }}
      >
        <div className="d-flex  w-100 h-100">
          <Sidebar special={special} clearModalData={clearModalData} />

          <div className="w-100" style={{ height: "100%" }}>
            <DashboardHeader />
            <div className="main-panel">
              <div
                className="content-wrapper px-4 px-lg-4"
                style={{
                  // padding: "15px",
                  flex: "1",
                  backgroundColor: "#000",
                  color: "#ffffff",
                  height: "100%",
                  overflowY: "auto",
                }}
              >
                                {isLoading ? (
                  <div className="p-sm-4 text-center">
                    <img
                      src={`${config.baseUrl}images/loader.gif`}
                      width="30px"
                      alt=""
                    />
                  </div>
                ) :
                <Container fluid>
                  <div className="dashboard-card detail process_form my-4 p-3">
                    <Row>
                      <h4 className="mb-0">Your Liquidity</h4>
                      {liqForm && liqForm.length > 0 ? (
                        liqForm.map((item, index) => (
                          <Col key={index} lg={12} className="mb-4">
                            <div className="d-flex justify-content-between pt-2">
                              <div className="d-flex align-items-center"></div>
                            </div>

                            <div className="mt-4">
                              <div className="wrapper p-0 overflow-hidden">
                                {/* Card Header */}
                                <div className="card-header d-flex justify-content-between p-3">
                                  <div>
                                    <div className="d-flex align-items-center">
                                      <div
                                        className="me-2"
                                        style={{ lineHeight: "1.4" }}
                                      >
                                        <div className="fw-bold">
                                          Pair Name : {item.pair_name}
                                          <img
                                            src={`${config.imagePath}${item.chainName}.png`}
                                            alt=""
                                            width={18}
                                            className="ms-1"
                                            style={{ marginTop: "-4px" }}
                                          />
                                        </div>
                                        <div className="fw-bold">
                                          Token Address:{" "}
                                          <a
                                            href={`${item.chainExplorerUrl}/address/${item.token_address}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                        {item.token_address}
                                      </a>
                                        </div>
                                        <div className="fw-bold">
                                          Price : 1 {item.token_name} =
                                          <span className="fw-medium">
                                            {" "}
                                            {item.PRICE} USDT
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  {/* Manage Toggle */}
                                  <div>
                                    <div
                                      className="h-100 d-flex align-items-center justify-content-end"
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        setIsOpen((prev) => ({
                                          ...prev,
                                          [index]: !prev[index],
                                        }))
                                      }
                                    >
                                      <div className="d-flex justify-content-end fw-bold text-primary">
                                        <span>Manage</span>
                                        <span>
                                          {" "}
                                          <IoIosArrowDown />{" "}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                {/* Collapsible Info */}
                                <Collapse in={isOpen?.[index]}>
                                  <div className="p-3 pt-0">
                                    <div className="mt-3">
                                      <div className="d-flex justify-content-between">
                                        <div className="fw-bold">
                                          Total LP tokens
                                        </div>
                                        <div>{item.LPBAL}</div>
                                      </div>

                                      <div className="d-flex justify-content-between mt-3">
                                        <div className="fw-bold">
                                          Pooled {item.token_name}
                                        </div>
                                        <div className="d-flex align-items-center">
                                          <span className="me-1">
                                            {item.BALANCES.Token}
                                          </span>
                                        </div>
                                      </div>

                                      <div className="d-flex justify-content-between mt-3">
                                        <div className="fw-bold">
                                          Pooled USDT
                                        </div>
                                        <div className="d-flex align-items-center">
                                          <span className="me-1">
                                            {item.BALANCES.USDT}
                                          </span>
                                        </div>
                                      </div>
-------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
                                      <div className="d-flex justify-content-between mt-3">
                                        <div className="fw-bold">
                                          Bot Token Balance
                                        </div>
                                        <div className="d-flex align-items-center">
                                          <span className="me-1">
                                            {item.botBalToken || "--"} 
                                          </span>
                                        </div>
                                      </div>

                                      <div className="d-flex justify-content-between mt-3">
                                        <div className="fw-bold">
                                        Bot USDT Balance                                        
                                      </div>
                                        <div className="d-flex align-items-center">
                                          <span className="me-1">
                                            {item.botBalUsdt || "--"}
                                          </span>
                                        </div>
                                      </div>

                                      <div className="d-flex justify-content-between mt-3">
                                        <div className="fw-bold">
                                        {`Bot ${item.chainName} Balance`}
                                        </div>
                                        <div className="d-flex align-items-center">
                                          <span className="me-1">
                                            {item.botBalNative || "--"}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </Collapse>

                                {/* Actions */}
                                <div className="p-3 pt-0">
                                <div className="d-flex flex-wrap gap-2 align-items-center gap-5">
                                  <Button
                                    variant="custombtn"
                                    className="text-black btn-sm px-3"
                                    onClick={(e) => handleModalShow(e, item)}
                                  >
                                    Add Liquidity
                                  </Button>

                                  <Button
                                    variant="custombtn"
                                    className="text-black btn-sm px-3"
                                    onClick={(e) => handleBotShow(e, item)}
                                    disabled={item.bot_bot_is_active}
                                  >
                                    Register Bot
                                  </Button>

                                  <Button
                                    variant="custombtn"
                                    className="text-black btn-sm px-3"
                                    onClick={(e) => handleBotSettingsShow(e, item)}
                                    disabled={!item.bot_bot_is_active}
                                  >
                                    Bot Settings
                                  </Button>

                                  {liqForm.length > 0 && !item.canRemove ? (
                                    <Button
                                      variant="custombtn"
                                      className="text-black btn-sm px-3"
                                      onClick={requestRemoveLiquidity}
                                    >
                                      Request To Remove Liquidity
                                    </Button>
                                  ) : (
                                    <Button
                                      variant="custombtn"
                                      className="text-black btn-sm px-3"
                                      onClick={(e) => handleModalShow2(e, item)}
                                    >
                                      Remove Liquidity
                                    </Button>
                                  )}
                                </div>
                              </div>
                              </div>
                            </div>
                          </Col>
                        ))
                      ) : (
                        <div className="d-flex justify-content-center align-items-center">
                          <div className="text-center mt-5">
                            <div>
                              <img
                                src={`${config.baseUrl}images/Search.png`}
                                alt="No Data Found"
                                className="img-fluid noliquidityImg"
                                width={150}
                              />
                            </div>
                            <div className="fs-3 fw-bold mt-3">
                              No Liquidity found
                            </div>
                          </div>
                        </div>
                      )}

                      <Modal show={showModal} onHide={handleModalClose}>
                        <Modal.Header closeButton>
                          <Modal.Title>
                            <b>Add Liquidity</b>
                          </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <div className="mb-3">
                            {selectedTokenItem && (
                              <Row>
                                <Col lg={12}>
                                  <Form.Group className="mb-3">
                                    <Form.Control
                                      placeholder="Enter token amount"
                                      name="tokenamount"
                                      className="small"
                                      value={tokenAmt || ""}
                                      onChange={inputhandler}
                                    />
                                    {inputError && (
                                      <div className="text-danger mt-1 small">
                                        {inputError}
                                      </div>
                                    )}
                                  </Form.Group>
                                  <Form.Group>
                                    <Form.Control
                                      placeholder="USDT Amount"
                                      name="USDT"
                                      className="small"
                                      value={usdtAmtToAdd || ""}
                                      disabled
                                    />
                                  </Form.Group>
                                </Col>
                              </Row>
                            )}
                          </div>
                          <div className="mt-4">
                            <Button
                              variant="primary"
                              className="w-100"
                              disabled={inputError}
                              onClick={(e) => {
                                handleAddLiquidity(e);
                              }}
                            >
                              Confirm Supply{" "}
                            </Button>
                          </div>
                        </Modal.Body>
                      </Modal>
                      <Modal show={removeModal} onHide={handleModalClose2}>
                        <Modal.Header closeButton>
                          <Modal.Title>
                            <b></b>
                          </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <div className="mb-2">
                            {selectedTokenItem && (
                              <Row>
                                <Col lg={12}>
                                  <Form.Group>
                                    <Form.Control
                                      placeholder="Enter LP Token"
                                      name="lptoken"
                                      className="small"
                                      value={lpAmt || ""}
                                      onChange={inputhandler2}
                                    />
                                    {inputError && (
                                      <div className="text-danger mt-1 small">
                                        {inputError}
                                      </div>
                                    )}
                                  </Form.Group>
                                </Col>
                              </Row>
                            )}
                          </div>
                          {selectedTokenItem && (
                            <div>
                              <div className="d-flex justify-content-between">
                                <div className="fw-bold">Your LP Balance</div>
                                <div className="">
                                  {selectedTokenItem.LPBAL}
                                </div>
                              </div>
                              <div className="border mt-2 rounded-2 overflow-hidden">
                                <div className="text-center py-2 bg-light border-bottom">
                                  <h6 className="fw-bold mb-0">
                                    You Will Receive{" "}
                                  </h6>
                                </div>

                                <div className="d-flex justify-content-between my-2 px-2">
                                  <div className="fw-bold">
                                    {selectedTokenItem.token_name}
                                  </div>
                                  <div className="">
                                    {expected?.Token || ""}
                                  </div>
                                </div>
                                <div className="d-flex justify-content-between my-2 px-2">
                                  <div className="fw-bold">USDT</div>
                                  <div className="">{expected?.USDT || ""}</div>
                                </div>
                                <div className="d-flex justify-content-between my-2 px-2">
                                  <div className="fw-bold">PENALTY</div>
                                  <div className="">
                                    {expected?.PENALTY || ""}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          <div className="mt-4">
                            <Button
                              variant="primary"
                              className="w-100"
                              disabled={inputError}
                              onClick={(e) => {
                                handleRemoveLiquidity(e);
                              }}
                            >
                              Confirm{" "}
                            </Button>
                          </div>
                        </Modal.Body>
                      </Modal>
                {/* ====================================== Bot Register ================================= */}
                      <>
                      <Modal show={showBuyInfiModal} onHide={() => setShowBuyInfiModal(false)} centered>
                          <Modal.Header closeButton>
                            <Modal.Title>Insufficient INFI Balance</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <p>You need at least <strong>10 INFI</strong> tokens to use this feature.</p>
                            <p>Would you like to buy INFI now?</p>
                          </Modal.Body>
                          <Modal.Footer>
                            <Button variant="secondary" onClick={() => setShowBuyInfiModal(false)}>
                              Cancel
                            </Button>
                            <Button variant="primary" onClick={() => window.open('https://infimultichain.com/ico/', '_blank')}>
                              Buy INFI
                            </Button>
                          </Modal.Footer>
                        </Modal>

                    <Modal show={showBot} onHide={handleBotClose} dialogClassName="botmodal">
                              <Modal.Header closeButton >
                                  <Modal.Title>Register For AMM Bot {selectedTokenBotItem.token_name} </Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                                  <div>
                                  <Col htmlFor="Token" className="mb-0">
                                  <img
                                    src={`${config.imagePath}${selectedTokenBotItem.brand_logo}`}
                                    width={`20px`}
                                    alt=""
                                  />{' '}Token Address: {" "}
                                  <a
                                   href={`${selectedTokenBotItem.chainExplorerUrl}/address/${selectedTokenBotItem.token_address}`}
                                   target="_blank"
                                   rel="noopener noreferrer"
                                  >
                                    {selectedTokenBotItem.token_address}
                                  </a>
                                  </Col>
                                  <p></p>
                                      <Row>
                                          <Col lg={12} className="mb-3">
                                              <Form.Label htmlFor="email" className="mb-1">Email:</Form.Label>
                                              <Form.Control
                                                  type="email"
                                                  id="email"
                                                  aria-describedby="email"
                                                  placeholder="Example@gmail.com"
                                                  onChange={inputhandler3}
                                                  isInvalid={!!inputError}
                                              />
                                                <Form.Control.Feedback type="invalid">
                                                  {inputError}
                                                </Form.Control.Feedback>
                                              <p></p>
                                              <Form.Label controlId="phone" className="mb-1">Phone Number:</Form.Label>
                                              <PhoneInput
                                                country={'us'}
                                                enableSearch={true}
                                                value={phoneNumber}
                                                placeholder="Enter your phone"
                                                onChange={phoneInputhandler}
                                                inputProps={{
                                                  name: 'phone',
                                                  required: true,
                                                  className: `form-control ${inputError ? 'is-invalid' : ''}`
                                                }}
                                              />
                                                 {inputError && (
                                                  <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                                                    {inputError}
                                                  </Form.Control.Feedback>
                                                )}
                                              <p></p>
                                              <Col lg={12} className="mb-3">
                                              <Form.Label htmlFor="email" className="mb-1">Price Difference(in %):</Form.Label>
                                              <Form.Control
                                                  type="priceDiff"
                                                  id="priceDiff"
                                                  aria-describedby="priceDiff"
                                                  onChange={inputhandler5}
                                                  isInvalid={!!inputError}
                                              />
                                                <Form.Control.Feedback type="invalid">
                                                  {inputError}
                                                </Form.Control.Feedback>
                                              <p></p>
                                              <div className="d-flex align-items-center mb-3 switchBtn">
                                                <div className="me-2 mb-1 d-flex align-items-center">
                                                  <span className="me-1">
                                                  <img
                                                      src={`${config.baseUrl}images/usdt.svg`}
                                                      width={`20px`}
                                                      alt=""
                                                      />{' '}
                                                      Fees in USDT
                                                  </span>
                                                  <OverlayTrigger placement="top" overlay={renderTooltipUSDT}>
                                                    <span tabIndex={0} style={{ cursor: 'pointer' }}>
                                                      <i className="bi bi-info-circle" style={{ fontSize: '1.2rem' }}></i>
                                                    </span>
                                                  </OverlayTrigger>
                                                </div>
                                              </div>
                                            <Col lg={12} className="mb-md-2">
                                              <div className="d-md-flex justify-content-between align-items-end">
                                                  <Button 
                                                    size="sm" 
                                                    className="small fw-semibold"
                                                    onClick={handleBotWalletCreate}
                                                    disabled={inputError || !email || !priceDiffPercent || botWallet  }
                                                  >
                                                    {isGeneratingWallet ? (
                                                      <>
                                                        <Spinner animation="border" size="sm" className="me-2" />
                                                         Generating Wallet...
                                                      </>
                                                    ) : ('Generate Wallet')}
                                                  </Button>
                                              </div>
                                          </Col>
                                          <p></p>
                                          <Col lg={12} className="mb-3">
                                              <Form.Control
                                                  type="text"
                                                  id="walletaddress"
                                                  aria-describedby="walletaddress"
                                                  placeholder="Wallet Address"
                                                  value={botWallet}
                                                  disabled
                                              />
                                          </Col>
                                          </Col>
                                          <Col lg={12} className="mb-3">
                                              <Form.Label htmlFor="USDT" className="mb-1">
                                                  <img
                                                    src={`${config.baseUrl}images/usdt.svg`}
                                                    width={`20px`}
                                                    alt=""
                                                  />{' '}
                                                  USDT
                                                </Form.Label>
                                              <InputGroup className="">

                                                  <Form.Control
                                                      placeholder="USDT"
                                                      aria-label="USDT"
                                                      aria-describedby="basic-addon2"
                                                      value={usdtToDeposit}
                                                      disabled
                                                  />
                                                  {/* <Button 
                                                    variant="primary" 
                                                    id="button-addon2"
                                                    onClick={(e) => handleUsdtDeposit(e)}
                                                    disabled={!botWallet || isDepositingUsdt}>
                                                    {isDepositingUsdt ? (
                                                          <>
                                                          <Spinner animation="border" size="sm" className="me-2" />
                                                          Depositing...
                                                        </>
                                                      ) : (
                                                        "Deposit"
                                                      )}
                                                  </Button> */}
                                              </InputGroup>
                                          </Col>
                                          <Col lg={12} className="mb-3">
                                              <Form.Label htmlFor="Token" className="mb-1">
                                                <img
                                                    src={`${config.imagePath}${selectedTokenBotItem.brand_logo}`}
                                                    width={`20px`}
                                                    alt=""
                                                />{' '}
                                                  {selectedTokenBotItem.token_name} Token
                                                  </Form.Label>
                                              <InputGroup className="">

                                                  <Form.Control
                                                      placeholder="Token"
                                                      aria-label="Token"
                                                      aria-describedby="basic-addon2"
                                                      value={tokenToDeposit}
                                                      disabled
                                                  />
                                                  {/* <Button variant="primary" id="button-addon2" onClick={handleTokenDeposit} disabled={!botWallet || isDepositingToken}>
                                                    {isDepositingToken ? (
                                                          <>
                                                          <Spinner animation="border" size="sm" className="me-2" />
                                                          Depositing...
                                                        </>
                                                      ) : (
                                                        "Deposit"
                                                      )}
                                                  </Button> */}
                                              </InputGroup>
                                          </Col>
                                          <Col lg={12} className="mb-3">
                                              <Form.Label htmlFor="Native" className="mb-1">
                                                <img
                                                    src={`${config.imagePath}${selectedTokenBotItem.chainName}.png`}
                                                    width={`20px`}
                                                    alt=""
                                                />{' '}
                                                {selectedTokenBotItem.chainSymbol}</Form.Label>
                                              <InputGroup className="">

                                                  <Form.Control
                                                      placeholder="Native"
                                                      aria-label="Native"
                                                      aria-describedby="basic-addon2"
                                                      onChange={inputhandler4}
                                                      value={nativeToDeposit}
                                                      isInvalid={!!inputError}
                                                  />
                                                  <Form.Control.Feedback type="invalid">
                                                      {inputError}
                                                </Form.Control.Feedback>
                                              </InputGroup>
                                          </Col>
                                          <Button variant="primary" id="button-addon2" onClick={(e) => handleNativeDeposit(e)} disabled={!botWallet || inputError || isDepositingNative || !nativeToDeposit}>
                                          {isDepositingNative ? (
                                            <>
                                            <Spinner animation="border" size="sm" className="me-2" />
                                            Depositing...
                                            </>
                                            ) : (
                                              "Deposit"
                                              )}
                                              </Button>
                                              </Col>
                                              </Row>
                                              </div>
                                              </Modal.Body>
                                              </Modal>
                                              </>

                {/* ====================================== Bot Settings ================================= */}
                      <>
                    <Modal show={showBotSettings} onHide={handleBotSettingsClose} dialogClassName="botmodal">
                              <Modal.Header closeButton >
                                  <Modal.Title>Bot Settings {selectedTokenBotItem.token_name} </Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                                  <div>
                                    {/* {console.log('i3',selectedTokenBotItem)} */}
                                  <Col htmlFor="Token" className="mb-0">
                                  <img
                                    src={`${config.imagePath}${selectedTokenBotItem.brand_logo}`}
                                    width={`20px`}
                                    alt=""
                                  />{' '}Token Address: {" "}
                                  <a
                                     href={`${selectedTokenBotItem.chainExplorerUrl}/address/${selectedTokenBotItem.token_address}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    {selectedTokenBotItem.token_address}
                                  </a></Col>
                                  <p></p>
                                  <Button 
                                    variant="primary" 
                                    onClick={(e) => handleBotStatus(e)}
                                    disabled={isHalting}
                                  >
                                    {isHalting ? (
                                    <>
                                    <Spinner animation="border" size="sm" className="me-2" />
                                    {botAction === "starting" ? "Starting..." : "Stopping..."}
                                    </>
                                    ) : (
                                      isBotHalted ? "Start Bot" : "Stop Bot")}
                                  </Button>   
                                  <p></p>
                                      <Row>
                                          <p></p>
                                          <Col htmlFor="Token" className="mb-0">Wallet Address :
                                          <Col lg={12} className="mb-3">
                                              <Form.Control
                                                  type="text"
                                                  id="walletaddress"
                                                  aria-describedby="walletaddress"
                                                  placeholder="Wallet Address"
                                                  value={selectedTokenBotItem.bot_wallet_address}
                                                  disabled
                                              />
                                          </Col>
                                          </Col>
                                          <Col lg={12} className="mb-3">
                                              <Form.Label htmlFor="USDT" className="mb-1">
                                                <img
                                                  src={`${config.baseUrl}images/usdt.svg`}
                                                  width={`20px`}
                                                  alt=""
                                              />{' '}
                                                  USDT</Form.Label>
                                              <InputGroup className="">
                                                  <Form.Control
                                                      placeholder="USDT"
                                                      aria-label="USDT"
                                                      aria-describedby="basic-addon2"
                                                      onChange={addUsdtinputhandler}
                                                      value={usdtToAddToBot}
                                                      isInvalid={!!inputError}
                                              />
                                                <Form.Control.Feedback type="invalid">
                                                  {inputError}
                                                </Form.Control.Feedback>
                                                  <Button 
                                                    variant="primary" 
                                                    id="button-addon2"
                                                    onClick={(e) => handleUsdtToAdd(e)}
                                                    disabled={isAddingUsdt}>
                                                    {isAddingUsdt ? (
                                                          <>
                                                          <Spinner animation="border" size="sm" className="me-2" />
                                                          Depositing...
                                                        </>
                                                      ) : (
                                                        "Deposit"
                                                      )}
                                                  </Button>
                                              </InputGroup>
                                          </Col>
                                          <Col lg={12} className="mb-3">
                                              <Form.Label htmlFor="Token" className="mb-1">
                                                <img
                                                    src={`${config.imagePath}${selectedTokenBotItem.brand_logo}`}
                                                    width={`20px`}
                                                    alt=""
                                                />{' '}
                                                {selectedTokenBotItem.token_name} Token</Form.Label>
                                              <InputGroup className="">

                                                  <Form.Control
                                                      placeholder="Token"
                                                      aria-label="Token"
                                                      aria-describedby="basic-addon2"
                                                      onChange={addTokeninputhandler}
                                                      value={tokenToAddToBot}
                                                      isInvalid={!!inputError}
                                              />
                                                <Form.Control.Feedback type="invalid">
                                                  {inputError}
                                                </Form.Control.Feedback>
                                                  <Button variant="primary" id="button-addon2" onClick={handleTokenToAdd} disabled={isAddingToken}>
                                                    {isAddingToken ? (
                                                          <>
                                                          <Spinner animation="border" size="sm" className="me-2" />
                                                          Depositing...
                                                        </>
                                                      ) : (
                                                        "Deposit"
                                                      )}
                                                  </Button>
                                              </InputGroup>
                                          </Col>
                                          <Col lg={12} className="mb-3">
                                              <Form.Label htmlFor="Native" className="mb-1">
                                                <img
                                                    src={`${config.imagePath}${selectedTokenBotItem.chainName}.png`}
                                                    width={`20px`}
                                                    alt=""
                                                />{' '}
                                                {selectedTokenBotItem.chainSymbol}</Form.Label>
                                              <InputGroup className="">

                                                  <Form.Control
                                                      placeholder="Native"
                                                      aria-label="Native"
                                                      aria-describedby="basic-addon2"
                                                      onChange={inputhandler4}
                                                      value={nativeToDeposit}
                                                      isInvalid={!!inputError}
                                                  />
                                                  <Form.Control.Feedback type="invalid">
                                                      {inputError}
                                                </Form.Control.Feedback>
                                                  <Button variant="primary" id="button-addon2" onClick={(e) => handleNativeDeposit(e)} disabled={isDepositingNative}>
                                                  {isDepositingNative ? (
                                                          <>
                                                          <Spinner animation="border" size="sm" className="me-2" />
                                                          Depositing...
                                                        </>
                                                      ) : (
                                                        "Deposit"
                                                      )}
                                                  </Button>
                                              </InputGroup>
                                          </Col>
                                        </Row>
                                      </div>
                              </Modal.Body>
                              <Modal.Footer>
                                  <Button variant="primary"
                                  onClick={handleBotSettingsClose}>
                                    Close
                                  </Button>
                                  {isBotHalted && (
                                  <Button variant="primary"
                                  onClick={(e) => handleBotWithdrawShow(e,selectedTokenBotItem)}
                                  >
                                    Withdraw
                                  </Button>)}

                              </Modal.Footer>
                          </Modal>
                      </>

                {/* ====================================== Bot Withdraw ================================= */}
                         <>
                    <Modal show={showBotWithdraw} onHide={handleBotWithdrawClose} dialogClassName="botmodal">
                              <Modal.Header closeButton >
                                  <Modal.Title>Bot Settings For {selectedTokenBotItem.token_name} </Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                                  <div>
                                    {/* {console.log('i3',selectedTokenBotItem)} */}
                                  <Col htmlFor="Token" className="mb-0">
                                  <img
                                    src={`${config.imagePath}${selectedTokenBotItem.brand_logo}`}
                                    width={`20px`}
                                    alt=""
                                  />{' '}Token Address: {" "}
                                  <a
                                     href={`${selectedTokenBotItem.chainExplorerUrl}/address/${selectedTokenBotItem.token_address}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    {selectedTokenBotItem.token_address}
                                  </a></Col>                             
                                  <p></p>
                                      <Row>
                                          <p></p>
                                          <Col htmlFor="Token" className="mb-0">Wallet Address :
                                          <Col lg={12} className="mb-3">
                                              <Form.Control
                                                  type="text"
                                                  id="walletaddress"
                                                  aria-describedby="walletaddress"
                                                  placeholder="Wallet Address"
                                                  value={selectedTokenBotItem.bot_wallet_address}
                                                  disabled
                                              />
                                          </Col>
                                          </Col>
                                          <Col lg={12} className="mb-3">
                                              <Form.Label htmlFor="USDT" className="mb-1">
                                                <img
                                                  src={`${config.baseUrl}images/usdt.svg`}
                                                  width={`20px`}
                                                  alt=""
                                              />{' '}
                                                  USDT : {selectedTokenBotItem.botBalUsdt}</Form.Label>
                                              <InputGroup className="">
                                                  <Form.Control
                                                      placeholder="USDT"
                                                      aria-label="USDT"
                                                      aria-describedby="basic-addon2"
                                                      onChange={withdrawUsdtinputhandler}
                                                      value={botUsdtToWithdraw}
                                                      isInvalid={!!inputError}
                                              />
                                                <Form.Control.Feedback type="invalid">
                                                  {inputError}
                                                </Form.Control.Feedback>
                                                  <Button 
                                                    variant="primary" 
                                                    id="button-addon2"
                                                    onClick={(e) => handleUsdtToWithdraw(e)}
                                                    disabled={isRemovingUsdt}>
                                                    {isRemovingUsdt ? (
                                                          <>
                                                          <Spinner animation="border" size="sm" className="me-2" />
                                                          Withdraw In Progress...
                                                        </>
                                                      ) : (
                                                        "Withdraw"
                                                      )}
                                                  </Button>
                                              </InputGroup>
                                          </Col>
                                          <Col lg={12} className="mb-3">
                                              <Form.Label htmlFor="Token" className="mb-1">
                                                <img
                                                    src={`${config.imagePath}${selectedTokenBotItem.brand_logo}`}
                                                    width={`20px`}
                                                    alt=""
                                                />{' '}
                                                {selectedTokenBotItem.token_name} Token : {selectedTokenBotItem.botBalToken}</Form.Label>
                                              <InputGroup className="">

                                                  <Form.Control
                                                      placeholder="Token"
                                                      aria-label="Token"
                                                      aria-describedby="basic-addon2"
                                                      onChange={withdrawTokeninputhandler}
                                                      value={botTokenToWithdraw}
                                                      isInvalid={!!inputError}
                                              />
                                                <Form.Control.Feedback type="invalid">
                                                  {inputError}
                                                </Form.Control.Feedback>
                                                  <Button variant="primary" id="button-addon2" onClick={handleTokenToWithdraw} disabled={isRemovingToken}>
                                                    {isRemovingToken ? (
                                                          <>
                                                          <Spinner animation="border" size="sm" className="me-2" />
                                                          Withdraw In Progress...
                                                        </>
                                                      ) : (
                                                        "Withdraw"
                                                      )}
                                                  </Button>
                                              </InputGroup>
                                          </Col>
                                          <Col lg={12} className="mb-3">
                                              <Form.Label htmlFor="Native" className="mb-1">
                                                <img
                                                    src={`${config.imagePath}${selectedTokenBotItem.chainName}.png`}
                                                    width={`20px`}
                                                    alt=""
                                                />{' '}
                                                {selectedTokenBotItem.chainSymbol} : {selectedTokenBotItem.botBalNative}</Form.Label>
                                              <InputGroup className="">

                                                  <Form.Control
                                                      placeholder="Native"
                                                      aria-label="Native"
                                                      aria-describedby="basic-addon2"
                                                      onChange={withdrawNativeinputhandler}
                                                      value={botNativeToWithdraw}
                                                      isInvalid={!!inputError}
                                                  />
                                                  <Form.Control.Feedback type="invalid">
                                                      {inputError}
                                                </Form.Control.Feedback>
                                                  <Button variant="primary" id="button-addon2" onClick={handleNativeToWithdraw} disabled={isRemovingNative}>
                                                  {isRemovingNative ? (
                                                          <>
                                                          <Spinner animation="border" size="sm" className="me-2" />
                                                          Withdraw In Progress...
                                                        </>
                                                      ) : (
                                                        "Withdraw"
                                                      )}
                                                  </Button>
                                              </InputGroup>
                                          </Col>
                                        </Row>
                                      </div>
                              </Modal.Body>
                              <Modal.Footer>
                                  <Button variant="primary"
                                  onClick={handleBotWithdrawClose}>
                                    Close
                                  </Button>
                              </Modal.Footer>
                          </Modal>
                      </>

                      {/* ====================================== Presale Settings ================================= */}
                      <Col lg={12} className="">
                        <div className="">
                          <h3 className="mb-4">Withdraw Presale tokens</h3>
                          <Table
                            striped
                            bordered
                            hover
                            responsive
                            className="mb-0"
                          >
                            <thead>
                              <tr>
                                <th>S.No</th>
                                <th>Token Name</th>
                                <th>Chain</th>
                                <th>Token Address</th>
                                <th>Duration</th>
                                {/* <th>Sale Status</th> */}
                                <th>Update Presale Duration</th>
                                <th>Withdrawal</th>
                              </tr>
                            </thead>
                            <tbody>
                              {form && form.length > 0 ? (
                                form.map((item, index) => (
                                  <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{item.token_name}</td>
                                    <td>{item.chainName}</td>
                                    <td>
                                      <div className="d-flex align-items-center">
                                        <span className="me-2">
                                          {item.token_address
                                            ? `${item.token_address.slice(
                                                0,
                                                6
                                              )}...${item.token_address.slice(
                                                -4
                                              )}`
                                            : "N/A"}
                                        </span>
                                        {/* Optional: Copy Icon */}
                                        <i
                                          className="fas fa-copy text-secondary"
                                          style={{ cursor: "pointer" }}
                                          title="Copy Address"
                                          onClick={() =>
                                            navigator.clipboard.writeText(
                                              item.token_address
                                            )
                                          }
                                        ></i>
                                      </div>
                                    </td>
                                    <td>
                                      <b>{item.duration}</b>
                                    </td>
                                    <td>
                                      <div>
                                        <Button
                                          variant="dark"
                                          className="h-auto btn-sm rounded-5 px-3 me-2 fw-normal text-nowrap"
                                          disabled={item.newD}
                                          onClick={(e) => handleShow(e, item)}
                                        >
                                          Update
                                        </Button>
                                      </div>
                                    </td>
                                    <td>
                                      <div>
                                        {!item.canWithdraw ? (
                                          <Button
                                            variant="dark"
                                            className="h-auto btn-sm rounded-5 px-3 me-2 fw-normal text-nowrap"
                                            onClick={(e) =>
                                              handleShow2(e, item)
                                            }
                                          >
                                            Request Withdrawal
                                          </Button>
                                        ) : (
                                          <Button
                                            variant="dark"
                                            className="h-auto btn-sm rounded-5 px-3 me-2  fw-normal text-nowrap"
                                            onClick={(e) => handleWithdrawal}
                                          >
                                            Withdraw
                                          </Button>
                                        )}
                                      </div>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="6">No data available</td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Container>}
                {/* --------Duration Modal Start-------- */}
                <Modal show={show} onHide={handleClose} className="modalStyle">
                  <Modal.Header closeButton>
                    <Modal.Title>Duration</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <div>
                      <div className="fw-medium mb-3">
                        Token Name: {selectedItem.token_name}
                      </div>
                      <div className="fw-medium mb-3">
                        Token Address: {selectedItem.token_address}
                      </div>
                      <Form.Group>
                        <Form.Label>Enter New Duration</Form.Label>
                        <Form.Control
                          type="text"
                          name="duration"
                          placeholder="Value"
                          value={request.duration}
                          onChange={handleInputChange}
                          isInvalid={!!errors.duration}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.duration}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </div>
                  </Modal.Body>
                  <Modal.Footer>
                    <p className="text-muted small fst-italic">
                      Note - New duration will not be added to existing duration
                    </p>
                    <Button
                      variant="dark"
                      onClick={(e) => handleUpdateDuration(e)}
                    >
                      UPDATE
                    </Button>
                  </Modal.Footer>
                </Modal>
                {/* -------Withdraw  Modal Start------- */}
                <Modal
                  show={withdraw}
                  onHide={handleClose2}
                  className="modalStyle"
                >
                  <Modal.Header closeButton>
                    <Modal.Title>Withdraw</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <div>
                      <div className="fw-medium mb-3">
                        Token Name: {selectedItem.token_name}
                      </div>
                      <div className="fw-medium mb-3">
                        Token Address: {selectedItem.token_address}
                      </div>
                      <Form.Group>
                        <Form.Label>Reason for Withdrawal</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={3}
                          type="text"
                          name="reason"
                          placeholder="text"
                          value={request.reason}
                          onChange={handleInputChange}
                          isInvalid={!!errors.reason}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.reason}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </div>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="dark" onClick={handleWithdrawRequest}>
                      SEND
                    </Button>
                  </Modal.Footer>
                </Modal>


              </div>
              <Footer />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardHome;
